export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="web端-8.26修改" transform="translate(-1448.000000, -5077.000000)" stroke="currentColor" strokeWidth="1.5">
                    <g id="编组-7备份-4" transform="translate(1236.000000, 5053.400313)">
                        <g id="编组-6" transform="translate(30.000000, 19.000000)">
                            <g
                                id="编组-5"
                                transform="translate(193.626963, 17.147778) rotate(-315.000000) translate(-193.626963, -17.147778) translate(187.422284, 8.453507)"
                            >
                                <line x1="6.31613603" y1="0.388543223" x2="6.31613603" y2="16.7630597" id="路径-2"></line>
                                <polyline
                                    id="路径"
                                    transform="translate(6.204679, 6.204679) rotate(-45.000000) translate(-6.204679, -6.204679) "
                                    points="1.81730848 1.81730848 10.59205 1.81730848 10.59205 10.59205"
                                ></polyline>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
